import type { PaymentMethodsData } from "~/core";

export const isPaymentMethods = (item: unknown): item is PaymentMethodsData => {
  return (
    typeof item === "object" &&
    item !== null &&
    "__typename" in item &&
    item.__typename === "payment_methods"
  );
};
